import React from 'react';
import { motion } from 'framer-motion';

const SocialLink = ({ 
  name, 
  url, 
  className = "",
  children = null 
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.a
      href={url}
      onClick={handleClick}
      className={`text-white/60 hover:text-white transition-colors duration-300 text-sm ${className}`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      {children || name}
    </motion.a>
  );
};

export default SocialLink; 